import { useEffect, useRef } from 'react';
import { trackScrollDepth } from '../utils/googleAnalytics';

export const useScrollTracking = () => {
  const trackedDepths = useRef(new Set());

  useEffect(() => {
    let ticking = false;

    const updateScrollDepth = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      const scrollPercent = Math.round((scrollTop / scrollHeight) * 100);

      // Track at 25%, 50%, 75%, and 100%
      const milestones = [25, 50, 75, 100];

      milestones.forEach(milestone => {
        if (scrollPercent >= milestone && !trackedDepths.current.has(milestone)) {
          trackedDepths.current.add(milestone);
          trackScrollDepth(milestone);
        }
      });

      ticking = false;
    };

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(updateScrollDepth);
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll);

    // Check initial scroll position
    updateScrollDepth();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
};
